import React from "react";
import MyNav from "./MyNav";
import Design from "./Design";

const Home = () => {
  return (
    <div id="#home">
      <MyNav />
      <Design />
    </div>
  );
};

export default Home;
